module.exports = __webpack_public_path__ + "static/media/YF52_2.899ddb1a.jpg";